import React from "react";
import LayoutProjects from "./LayoutProjects";
import PersonalImg from "../../img/png/personal-img.png";
import PersonalVideo from "../../img/mp4/personal-video.mp4";

export default function Personal() {
  let language = localStorage.getItem("language");

  return (
    <LayoutProjects
      title={language === "english" ? "PERSONAL PAGE" : "PÁGINA PERSONAL"}
      features={
        language === "english"
          ? ["Login", "Modal images", "Menu responsive", "Whatsapp Modal"]
          : [
              "Inicio de sesión",
              "Imágenes en modal",
              "Menu responsivo",
              "Whatsapp Modal",
            ]
      }
      img={PersonalImg}
      description={
        language === "english"
          ? "Web page created in 2019, i take three weeks coding it, i used JavaScript, Html and CSS for the front, PHP and MySQL for the back."
          : "Página web creada en el 2019, me tomó tres semanas codificarla, usé JavaScript, HTML y CSS para el front, PHP y MySQL para el back."
      }
      color="#232342"
      textColor="#fff"
      video={PersonalVideo}
      tecno={["HTML", "CSS", "JavaScript", "PHP", "MySQL"]}
      link="http://yojhanatuesta.000webhostapp.com/"
    />
  );
}
